import defaultValues from './defaultValues'

const hover = JSON.parse(defaultValues);

export default hover;